// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { MdmGroupVO } from '@user/model/vo/user.vo';

@JsonObject('UserRightsInfoVO')
export class UserRightsInfoVO {
  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('login', 'String')
  public login: string = undefined;

  @JsonProperty('role', 'String')
  public role: string = undefined;

  @JsonProperty('userRights', '[String]')
  public userRights: string[] = new Array<string>();

  @JsonProperty('mdmGroup', 'MdmGroupVO')
  public mdmGroup: MdmGroupVO = null;
}
